import { css } from 'styled-components';

export interface WithDimensionsProps {
  h?: string;
  w?: string;
  maxHeight?: string;
  maxWidth?: string;
  minHeight?: string;
  minWidth?: string;
  overflow?: string;
  overflowX?: string;
  overflowY?: string;
  scrollBehavior?: string;
  aspectRatio?: string;
  resize?: string;
  fullWidth?: boolean;
}

export const withDimensionsCSS = ({
  h,
  w,
  fullWidth,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  overflow,
  overflowX,
  overflowY,
  scrollBehavior,
  aspectRatio,
  resize,
}: WithDimensionsProps) => css`
  ${h && `height: ${h};`}
  ${!fullWidth && w && `width: ${w};`}
  ${!w && fullWidth && 'width: 100%;'}

  ${maxHeight && `max-height: ${maxHeight};`}
  ${maxWidth && `max-width: ${maxWidth};`}
  ${minHeight && `min-height: ${minHeight};`}
  ${minWidth && `min-width: ${minWidth};`}

  ${overflow && !overflowX && !overflowY && `overflow: ${overflow};`}
  ${
    overflowX &&
    `
    overflow-x: ${overflowX};

    ${
      overflowX === 'scroll' &&
      `
      &::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;
    `
    }
  `
  }
  ${overflowY && `overflow-y: ${overflowY};`}
  ${scrollBehavior && `scroll-behavior: ${scrollBehavior}`}

  ${aspectRatio && `aspect-ratio: ${aspectRatio.replace(':', '/')};`}
  ${resize && `resize: ${resize};`}
`;
